module.exports = __webpack_public_path__ + "media/images/humbleicons_ai-89613a03.png";